import React from 'react';
import { Link } from 'react-router-dom';
import './ConfigBreadcrumb.css';

/**
 * items: [{ label, to? }] — last item is current (no link)
 * Non-last items with `to` are links; without `to` they render as plain text.
 */
const ConfigBreadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <nav aria-label="breadcrumb" className="config-breadcrumb">
      <ol className="config-breadcrumb__list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={`${item.label}-${index}`}
              className={`config-breadcrumb__item ${isLast ? 'is-current' : ''}`}
            >
              {!isLast && item.to ? (
                <Link to={item.to}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default ConfigBreadcrumb;
